import Icon from "components/general/Icon";
import React from "react";
import icon from "images/ic_check_unfilled.png";
import iconChecked from "images/ic_check_filled.png";
import iconError from "images/ic_checkbox_error.png";
import styled from "styled-components";
import theme from "styles/theme";

const Container = styled.div`
  width: 100%;

  ${(props) =>
    props.isCentered
      ? `
    display: flex;
    justify-content: center;
  `
      : ""};
`;

const StyledLabel = styled.label`
  display: block;
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  // Hide checkbox visually but remain accessible to screen readers.
  // Source: https://polished.js.org/docs/#hidevisually
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckbox = styled.div`
  margin-right: ${theme.spacing.unit * 1}px;

  img {
    display: block;
  }
`;

const Label = styled.div`
  width: 100%;

  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: ${(props) =>
    props.$isChecked ? theme.colors.gray4 : theme.colors.gray3};
`;

const RequiredAsterisk = styled.span`
  color: ${theme.colors.dashboardRed};
`;

const Checkbox = ({
  className,
  isChecked,
  isDisabled,
  error,
  label,
  isCentered,
  isRequired,
  ...props
}) => {
  let iconSource = icon;
  if (isChecked) {
    iconSource = iconChecked;
  } else if (error) {
    iconSource = iconError;
  }

  return (
    <Container isCentered={isCentered}>
      <StyledLabel>
        <CheckboxContainer className={className}>
          <HiddenCheckbox
            checked={isChecked}
            {...props}
            disabled={isDisabled}
          />
          <StyledCheckbox>
            <Icon
              src={iconSource}
              iconColor={isDisabled ? theme.colors.gray3 : theme.colors.black}
              size={24}
            />
          </StyledCheckbox>
          <Label $isChecked={isChecked}>
            {label}
            {isRequired && <RequiredAsterisk>*</RequiredAsterisk>}
          </Label>
        </CheckboxContainer>
      </StyledLabel>
    </Container>
  );
};

export default Checkbox;
